import { Route } from 'react-router-dom';

import { RoutesInternal, Loader } from 'theSource/components';
import { useMyCompanyQuery } from 'theSource/queries';
import { MyCompanyReviewPage } from './MyCompanyReviewPage';
import { MyCompanyViewPage } from './MyCompanyViewPage';
import { BenefitDocuments } from './BenefitDocuments';

export const MyCompany = () => {
  const { myCompanyCategoriesData, isLoading, isFetching } =
    useMyCompanyQuery();

  const isLoadingData = isLoading || isFetching || !myCompanyCategoriesData;

  if (isLoadingData) {
    return <Loader />;
  }

  return (
    <RoutesInternal>
      <Route
        path="/"
        element={<MyCompanyViewPage data={myCompanyCategoriesData} />}
      />
      <Route
        path=":id"
        element={<MyCompanyReviewPage data={myCompanyCategoriesData} />}
      />
      <Route path="/documents" element={<BenefitDocuments />} />
    </RoutesInternal>
  );
};
